<template>
  <DsShowcase title="ToggleButtonPlay" description="Toggle switch com v-model booleano.">
    <!-- Uso básico -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">Uso básico</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>v-model: boolean</code></p>
      <div class="tw:flex tw:flex-col tw:gap-4">
        <div class="tw:flex tw:items-center tw:gap-3">
          <ToggleButtonPlay v-model="toggle1" />
          <span class="tw:text-sm">Notificações: {{ toggle1 ? 'Ativado' : 'Desativado' }}</span>
        </div>
        <div class="tw:flex tw:items-center tw:gap-3">
          <ToggleButtonPlay v-model="toggle2" />
          <span class="tw:text-sm">Dark mode: {{ toggle2 ? 'Ativado' : 'Desativado' }}</span>
        </div>
        <div class="tw:flex tw:items-center tw:gap-3">
          <ToggleButtonPlay v-model="toggle3" />
          <span class="tw:text-sm">Modo público: {{ toggle3 ? 'Ativado' : 'Desativado' }}</span>
        </div>
      </div>
    </section>

    <!-- PROP: disabled -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">disabled</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>boolean</code> — bloqueia interação</p>
      <div class="tw:flex tw:flex-col tw:gap-4">
        <div class="tw:flex tw:items-center tw:gap-3">
          <ToggleButtonPlay :model-value="true" :disabled="true" />
          <span class="tw:text-sm tw:opacity-50">Ativado + disabled</span>
        </div>
        <div class="tw:flex tw:items-center tw:gap-3">
          <ToggleButtonPlay :model-value="false" :disabled="true" />
          <span class="tw:text-sm tw:opacity-50">Desativado + disabled</span>
        </div>
      </div>
    </section>

    <!-- PROP: name -->
    <section>
      <h2 class="tw:text-base tw:font-semibold tw:mb-1">name</h2>
      <p class="tw:text-xs tw:opacity-50 tw:mb-4"><code>string</code> — nome do input hidden (para formulários)</p>
      <div class="tw:flex tw:items-center tw:gap-3">
        <ToggleButtonPlay v-model="toggle4" name="newsletter" />
        <span class="tw:text-sm">Com name="newsletter"</span>
      </div>
    </section>
  </DsShowcase>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import DsShowcase from '../DsShowcase.vue'
import { ToggleButtonPlay } from '@/components/atomic'

const toggle1 = ref(true)
const toggle2 = ref(false)
const toggle3 = ref(true)
const toggle4 = ref(false)
</script>
